module.exports = __webpack_public_path__ + "static/media/best-friends-cover.ea6ac6eb.jpg";